
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"16","fill":"#FF8344"}}),_c('path',{attrs:{"d":"M15.478 11.054v.405c-1.529.388-2.387 1.824-2.387 3.45v2.909l-1.454 1.454c0 .322.4.728.727.728h8c.326 0 .727-.406.727-.727l-1.454-1.455v-2.91c0-1.625-.858-3.061-2.387-3.45v-.404a.88.88 0 00-.886-.872.88.88 0 00-.886.872zm-.205 9.673c0 .64.441 1.091 1.091 1.091.65 0 1.09-.45 1.09-1.09h-2.18z","fill":"#fff"}})])
          )
        }
      }
    